// extracted by mini-css-extract-plugin
export default {"section":"Collegial_section__c-0mF","pagination":"Collegial_pagination__vT2Xn"};